import SideMenuTimer from './SideMenuTimer'

export default SideMenuTimer
